// extracted by mini-css-extract-plugin
module.exports = {"summaryStyle":"_2Q5MR-Sj1jWE9zZ2-jWW_W"};